import React, { useState } from 'react'
import usePersistedFilters from "../../edvenswa.emportal.common/hooks/usePersistedFilters";
import ReportComponent from '../../edvenswa.emportal.reports/pages/ReportComponent'
import jsPDF from 'jspdf';
import { axiosInstance } from '../../../interceptors/AxiosInterceptor';
import moment from 'moment';
import { utils, write } from 'xlsx';
import XLSXStyle from 'xlsx-js-style';
import saveAs from "file-saver";
import { exportBiWeeklyRatingsExcel } from '../../edvenswa.emportal.common/utils/biWeeklyExcelExport';
import ExcelJS from "exceljs";
import { Chart, registerables } from "chart.js";

const AdminScreenAppraisal = (props) => {

    const { onError, setLoad, user } = props;
    const [startDateError, setStartDateError] = useState("");
    const [endDateError, setEndDateError] = useState("");
    const [appType, setAppType] = useState("Users");
    const [filteredElements, setFilteredElements] = useState([]);
    const [datefilter, setDateFilter] = useState("Last Bi-Weekly");
    const defaultStartDate = moment(new Date()).format('DD') > 15
        ? moment(new Date()).startOf('month').format('YYYY-MM-DD')
        : moment(new Date()).subtract(1, 'month').startOf('month').add(15, 'days').format('YYYY-MM-DD');
    const defaultEndDate = moment(new Date()).format('DD') > 15
        ? moment(new Date()).startOf('month').add(14, 'days').format('YYYY-MM-DD')
        : moment(new Date()).subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
    const [filters, setFilter] = usePersistedFilters("adminappraisal_filters", {
        startDate: defaultStartDate,
        endDate: defaultEndDate,
        tenantId: user.tenantId,
        sortBy: "ACTIVE",
    });
    const { startDate, endDate, tenantId, sortBy } = filters;
    const setStartDate = (val) => setFilter("startDate", val);
    const setEndDate = (val) => setFilter("endDate", val);
    const setTenantId = (val) => setFilter("tenantId", val);
    const setSortBy = (val) => setFilter("sortBy", val);

    const [ratingsEndDate, setRatingsEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [project, setProject] = useState("All");
    const [submissionFilter, setSubmissionFilter] = useState("All");

    // startdate should be start of month or 16 th of the month compulsary
    //enddate should be 15th or end of month
    let arr = [];
    if ((moment(startDate).format('DD') === '01' || moment(startDate).format('DD') === '16') &&
        (moment(endDate).format('DD') === '15' || moment(endDate).format('DD') === moment(endDate).daysInMonth().toString())) {
        let count = 1
        for (
            let i = moment(startDate);
            moment(i).isSameOrBefore(endDate);
            i = moment(i).add(1, "day")
        ) {
            if (moment(i).format('DD') === '01' || moment(i).format('DD') === '15' || moment(i).format('DD') === '16' || moment(i).format('DD') === moment(i).daysInMonth().toString()) {
                count++;
                if (count % 2 == 0) {
                    arr.push(moment(i).format("DD/MMM"))
                }
                else {
                    arr.push(moment(i).format("DD/MMM/YYYY"))
                }
            }
        }
    }
    else {
        console.log('select dates correctly... startdate should start of month and enddate should be end of month ')
    }

    const applySubmissionFilter = (rows, ratingsData) => {
        if (datefilter !== "Last Bi-Weekly" || submissionFilter === "All") return rows;
        return rows.filter((row) => getSubmissionLabel(row.associateId, ratingsData) === submissionFilter);
    };

    const getSubmissionLabel = (associateId, ratingsData) => {
        const ratingData = ratingsData?.[associateId];
        if (ratingData?.currentPeriodPmSubmitted === true) return "PM Submitted";
        if (ratingData?.currentPeriodUserSubmitted === true) return "Self Submitted";
        return "Not Submitted";
    };

    const handleDownloadReportExcel = async () => {
        try {
            if (appType === "Users") {
                const res = await axiosInstance.post(
                    `/user/getAllassociatesforRatings?sortBy=${sortBy}&tenantId=${tenantId}&project=${project}`,
                    { startDate, endDate }
                );
                let filteredElements = res.data;
                const astIds = filteredElements.map((user) => user?.associateId);
                let ratings = {};

                if (astIds.length > 0) {
                    const ratingsResponse = await axiosInstance.put(
                        `/user/get/past/ratings?endDate=${endDate}`,
                        astIds
                    );
                    ratings = ratingsResponse?.data || {};
                }

                filteredElements = applySubmissionFilter(filteredElements, ratings);
                filteredElements = [...filteredElements].sort((a, b) => (a.associateId || 0) - (b.associateId || 0));

                const fileName = `All Associates Ratings Report.xlsx`;

                if (filteredElements.length > 0) {
                    const isBiWeekly = datefilter === "Last Bi-Weekly";
                    const dateRange = `${moment(startDate).format("DD/MM/YYYY")} to ${moment(endDate).format("DD/MM/YYYY")}`;

                    const formattedData = filteredElements.map((row) => {
                        return {
                            "Ast ID": row?.associateId ? row?.associateId : "",
                            "Associate Name": row.firstname && row.lastname ? `${row.firstname} ${row.lastname}` : "",
                            "Projects": row.projectTitles,
                            "Project Manager": row?.projectManager?.fullname ?? "",
                            "Date Range": dateRange,
                            "Comments": "",
                            "UK Score": Math.floor((ratings?.[row?.associateId]?.finalRating || 0) * 180),
                            ...(isBiWeekly && { "Submission": getSubmissionLabel(row.associateId, ratings) }),
                            "userAppraislsList": row.userAppraisalsList ? row.userAppraisalsList : "",
                        };
                    });

                    let userArr = [];
                    let newObj = {};

                    for (let i = 0; i < arr.length; i++) {
                        if (i % 2 === 0) {
                            newObj = {
                                ...newObj,
                                [arr[i].concat(" - ").concat(arr[i + 1])]: 0,
                            };
                        }
                    }

                    formattedData.forEach((data) => {
                        let userObj = {};
                        let comment = "";

                        if (data["userAppraislsList"].length !== 0) {
                            let changedNewObj = { ...newObj };
                            data["userAppraislsList"].forEach((appraisal) => {
                                comment = appraisal.comments;
                                Object.keys(newObj).forEach((key) => {
                                    if (
                                        key ===
                                        moment(appraisal.startDate, "YYYY,MM,DD").format("DD/MMM").concat(" - ").concat(
                                            moment(appraisal.endDate, "YYYY,MM,DD").format("DD/MMM/YYYY")
                                        )
                                    ) {
                                        changedNewObj[key] = appraisal.ratings.toFixed(2);
                                    }
                                });
                            });
                            userObj = { ...data, ...changedNewObj, Comments: comment };
                        } else {
                            userObj = { ...data, ...newObj };
                        }
                        userArr.push(userObj);
                    });

                    const header = [
                        "Ast ID",
                        "Associate Name",
                        "Projects",
                        "Project Manager",
                        "Date Range",
                        "Comments",
                        "UK Score",
                        ...(isBiWeekly ? ["Submission"] : []),
                    ];
                    const newHeader = isBiWeekly ? header : header.concat(Object.keys(newObj));

                    const userData = userArr.map((val) => newHeader.map((h) => val[h] ?? ""));

                    // Build styled worksheet using xlsx-js-style
                    const submissionColIdx = isBiWeekly ? newHeader.indexOf("Submission") : -1;
                    const submissionColors = {
                        "PM Submitted": { fgColor: { rgb: "016466" } },
                        "Self Submitted": { fgColor: { rgb: "F57C00" } },
                        "Not Submitted": { fgColor: { rgb: "9E9E9E" } },
                    };

                    const headerStyle = {
                        font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
                        fill: { fgColor: { rgb: "008080" } },
                        alignment: { horizontal: "center", vertical: "center", wrapText: true },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };
                    const cellBorder = {
                        top: { style: "thin", color: { rgb: "CCCCCC" } },
                        bottom: { style: "thin", color: { rgb: "CCCCCC" } },
                        left: { style: "thin", color: { rgb: "CCCCCC" } },
                        right: { style: "thin", color: { rgb: "CCCCCC" } },
                    };

                    const wsData = [
                        newHeader.map((h) => ({ v: h, t: "s", s: headerStyle })),
                        ...userData.map((row, rIdx) =>
                            row.map((cell, cIdx) => {
                                const isSubmCol = cIdx === submissionColIdx;
                                const fillColor = isSubmCol ? submissionColors[cell]?.fgColor?.rgb : null;
                                return {
                                    v: cell ?? "",
                                    t: typeof cell === "number" ? "n" : "s",
                                    s: {
                                        font: { sz: 10, color: isSubmCol && fillColor ? { rgb: "FFFFFF" } : { rgb: "000000" } },
                                        fill: fillColor ? { fgColor: { rgb: fillColor } } : { fgColor: { rgb: rIdx % 2 === 0 ? "F5F5F5" : "FFFFFF" } },
                                        alignment: { vertical: "center", horizontal: cIdx === 0 || typeof cell === "number" ? "right" : "left" },
                                        border: cellBorder,
                                    },
                                };
                            })
                        ),
                    ];

                    const ws = XLSXStyle.utils.aoa_to_sheet(wsData);

                    // Column widths
                    ws["!cols"] = newHeader.map((h) => {
                        if (h === "Ast ID") return { wch: 8 };
                        if (h === "Associate Name") return { wch: 28 };
                        if (h === "Projects") return { wch: 30 };
                        if (h === "Project Manager") return { wch: 25 };
                        if (h === "Date Range") return { wch: 24 };
                        if (h === "Comments") return { wch: 20 };
                        if (h === "UK Score") return { wch: 10 };
                        if (h === "Submission") return { wch: 16 };
                        return { wch: 16 };
                    });
                    // Row height for header
                    ws["!rows"] = [{ hpt: 22 }, ...userData.map(() => ({ hpt: 18 }))];

                    const wb = XLSXStyle.utils.book_new();
                    XLSXStyle.utils.book_append_sheet(wb, ws, "data");
                    const excelBuffer = XLSXStyle.write(wb, { bookType: "xlsx", type: "array" });

                    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const data = new Blob([excelBuffer], { type: fileType });
                    saveAs(data, fileName);
                }
            } else {
                const fileName = `Project_Managers_Not_Submitted_Ratings.xlsx`;
                const formattedData = filteredElements.map((row) => {
                    return {
                        "Ast ID": row?.associateId ? row?.associateId : "",
                        "Associate Name": row.firstname && row.lastname ? `${row.firstname} ${row.lastname}` : "",
                        Projects: row.projectTitles,
                    };
                });

                const header1 = [
                    { label: "Ast ID", key: "Ast ID" },
                    { label: "Associate Name", key: "Associate Name" },
                    { label: "Projects", key: "Projects" },
                ];

                const worksheet = utils.json_to_sheet(formattedData, {
                    header: header1.map((h) => h.label),
                });
                const workbook = {
                    Sheets: { data: worksheet },
                    SheetNames: ["data"],
                };

                const excelBuffer = write(workbook, {
                    bookType: "xlsx",
                    type: "array",
                });

                const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName);
            }
        } catch (err) {
            onError(err);
        }
    };



    const handleDownloadReport = async () => {
        if (appType === "Users") {
            try {
                const response = await axiosInstance.post(`/user/getAllassociatesforRatings?sortBy=${sortBy}&tenantId=${tenantId}&project=${project}`, {
                    startDate,
                    endDate,
                });
                let filteredElements = response.data;

                if (filteredElements.length > 0) {
                    // Fetch ratings for all associates
                    const astIds = filteredElements.map(user => user?.associateId);
                    let ratings = {};

                    if (astIds.length > 0) {
                        try {
                            const ratingsResponse = await axiosInstance.put(`/user/get/past/ratings?endDate=${endDate}`, astIds);
                            ratings = ratingsResponse?.data || {};
                        } catch (err) {
                            console.error("Error fetching ratings:", err);
                        }
                    }

                    filteredElements = applySubmissionFilter(filteredElements, ratings);
                    filteredElements = [...filteredElements].sort((a, b) => (a.associateId || 0) - (b.associateId || 0));

                    // Proceed to generate the PDF
                    const pdfWidth = 210;
                    const pdfHeight = 250;
                    const pdf = new jsPDF({
                        orientation: "landscape",
                        unit: "mm",
                        format: [pdfWidth, pdfHeight],
                    });

                    const logoUrl = 'https://tse3.mm.bing.net/th?id=OIP.xrnfPsu-nIEVf0HzuyWt3AAAAA&pid=Api&P=0&h=180';
                    const centerX = pdf.internal.pageSize.width / 2;
                    const imageWidth = 20;
                    const imageHeight = 20;
                    const imageY = 2;

                    pdf.addImage(logoUrl, centerX - imageWidth / 2, imageY, imageWidth, imageHeight);

                    const isBiWeeklyPDF = datefilter === "Last Bi-Weekly";
                    const dateRange = `${moment(startDate).format("DD/MM/YYYY")} to ${moment(endDate).format("DD/MM/YYYY")}`;
                    const formattedData = filteredElements.map((row) => {
                        const ukScore = ratings?.[row?.associateId]?.finalRating
                            ? Math.floor(ratings[row.associateId].finalRating * 180)
                            : 0;

                        return {
                            "Ast ID": row?.associateId || "",
                            "Associate Name": row?.firstname && row?.lastname ? `${row.firstname} ${row.lastname}` : "",
                            "Projects": row?.projectTitles || "",
                            "Date Range": dateRange,
                            "UK Score": ukScore,
                            ...(isBiWeeklyPDF && { "Submission": getSubmissionLabel(row.associateId, ratings) }),
                        };
                    });

                    const header = ["Ast ID", "Associate Name", "Projects", "Date Range", "UK Score", ...(isBiWeeklyPDF ? ["Submission"] : [])];

                    const userData = formattedData.map((val) => header.map((h) => val[h] ?? ""));

                    const tableStartY = imageY + imageHeight + 20; //44

                    pdf.autoTable({
                        head: [header],
                        body: userData,
                        margin: { left: 8, right: 8, bottom: 10 },
                        startY: 58,
                        rowPageBreak: "avoid",
                        headStyles: { fillColor: "#008080", textColor: "#ffffff", fontStyle: "bold" },
                        didDrawPage: function (data) {
                            if (data.pageNumber === 1) {
                                pdf.setFont("Times New Roman, Times, serif");
                                pdf.text(`Dear Admin, Following is the report of All Users.`, 12, tableStartY - 6);
                                pdf.setFontSize(13);
                                pdf.text(
                                    `For the time period of ${moment(startDate).format("DD-MMM-yyyy")} to ${moment(endDate).format("DD-MMM-yyyy")} `,
                                    12,
                                    46
                                );
                            }
                        },
                        didParseCell: function (data) {
                            data.cell.styles.lineWidth = 0.1;
                            data.cell.styles.lineColor = [0, 0, 0];
                            if (isBiWeeklyPDF && data.column.dataKey === "Submission" && data.section === "body") {
                                const val = data.cell.raw;
                                if (val === "PM Submitted") { data.cell.styles.fillColor = [1, 100, 102]; data.cell.styles.textColor = [255, 255, 255]; }
                                else if (val === "Self Submitted") { data.cell.styles.fillColor = [245, 124, 0]; data.cell.styles.textColor = [255, 255, 255]; }
                                else { data.cell.styles.fillColor = [158, 158, 158]; data.cell.styles.textColor = [255, 255, 255]; }
                            }
                        },
                    });

                    pdf.save(`AllAssociateRatings.pdf`);
                }
            } catch (err) {
                console.error("Error generating report:", err);
            }
        } else {
            console.warn("Non-user report type handling is not implemented.");
        }
    };


    const handleDownloadAIReport = async () => {
        try {
            Chart.register(...registerables);

            const res = await axiosInstance.post(
                `/user/getAllassociatesforRatings?sortBy=${sortBy}&tenantId=${tenantId}&project=${project}`,
                { startDate, endDate }
            );
            let associates = res.data || [];
            const astIds = associates.map((u) => u?.associateId);
            let ratings = {};
            if (astIds.length > 0) {
                const ratingsRes = await axiosInstance.put(`/user/get/past/ratings?endDate=${endDate}`, astIds);
                ratings = ratingsRes?.data || {};
            }

            const parseAI = (raw) => { try { return raw ? JSON.parse(raw) : null; } catch { return null; } };
            const dateRange = `${moment(startDate).format("DD/MM/YYYY")} to ${moment(endDate).format("DD/MM/YYYY")}`;

            const TEAL  = "FF008080";
            const GREEN = "FF016466";
            const GRAY  = "FF9E9E9E";
            const WHITE = "FFFFFFFF";
            const BLACK = "FF000000";
            const LGRAY = "FFF5F5F5";
            const BGRAY = "FFCCCCCC";
            const solidFill  = (argb) => ({ type: "pattern", pattern: "solid", fgColor: { argb } });
            const thinBorder = (argb = BGRAY) => ({ style: "thin", color: { argb } });
            const allBorders = (argb = BGRAY) => ({ top: thinBorder(argb), bottom: thinBorder(argb), left: thinBorder(argb), right: thinBorder(argb) });

            const renderChartToPng = (config, width, height) => new Promise((resolve) => {
                const canvas = document.createElement("canvas");
                canvas.width = width; canvas.height = height;
                canvas.style.position = "absolute"; canvas.style.left = "-9999px";
                document.body.appendChild(canvas);
                const ctx = canvas.getContext("2d");
                ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, width, height);
                const chart = new Chart(canvas, { ...config, options: { ...config.options, animation: false, responsive: false } });
                const png = canvas.toDataURL("image/png").split(",")[1];
                chart.destroy(); document.body.removeChild(canvas);
                resolve(png);
            });

            // Analytics data
            const allAI = associates.map((row) => parseAI(ratings?.[row?.associateId]?.aiUsageData));
            const total = associates.length;
            const usingYes = allAI.filter((a) => a?.isUsingAI === "yes").length;
            const usingNo = allAI.filter((a) => a?.isUsingAI === "no").length;
            const notAnswered = total - usingYes - usingNo;
            const pct = (n) => total > 0 ? `${Math.round((n / total) * 100)}%` : "0%";

            const toolCount = {};
            allAI.filter((a) => a?.isUsingAI === "yes").forEach((a) => {
                (a.tool || "").split(",").map((t) => t.trim()).filter(Boolean).forEach((t) => { toolCount[t] = (toolCount[t] || 0) + 1; });
                if (a.otherTool?.trim()) toolCount[a.otherTool.trim()] = (toolCount[a.otherTool.trim()] || 0) + 1;
            });
            const sortedTools = Object.entries(toolCount).sort((a, b) => b[1] - a[1]);

            // Charts — render both in parallel
            const barHeight = Math.max(300, Math.min(sortedTools.length * 28 + 100, 900));
            const [donutPng, barPng] = await Promise.all([
                renderChartToPng({
                    type: "doughnut",
                    data: {
                        labels: [`Using AI (${pct(usingYes)})`, `Not Using AI (${pct(usingNo)})`, `Not Answered (${pct(notAnswered)})`],
                        datasets: [{ data: [usingYes, usingNo, notAnswered], backgroundColor: ["rgba(0,128,128,0.85)", "rgba(158,158,158,0.85)", "rgba(229,57,53,0.85)"], borderWidth: 2, borderColor: ["#008080", "#9E9E9E", "#E53935"] }],
                    },
                    options: { plugins: { title: { display: true, text: "AI Adoption Rate", font: { size: 14, weight: "bold" } }, legend: { display: true, position: "bottom", labels: { font: { size: 11 } } } } },
                }, 420, 420),
                sortedTools.length > 0 ? renderChartToPng({
                    type: "bar",
                    data: {
                        labels: sortedTools.map(([t]) => t),
                        datasets: [{ label: "# Associates", data: sortedTools.map(([, c]) => c), backgroundColor: "rgba(0,128,128,0.85)", borderWidth: 0, barThickness: 16 }],
                    },
                    options: {
                        indexAxis: "y",
                        plugins: { title: { display: true, text: "AI Tools Used", font: { size: 14, weight: "bold" } }, legend: { display: false } },
                        scales: { x: { beginAtZero: true, ticks: { stepSize: 1 }, title: { display: true, text: "# Associates" } }, y: { ticks: { font: { size: 10 }, autoSkip: false } } },
                    },
                }, 700, barHeight) : Promise.resolve(null),
            ]);

            // Workbook
            const workbook = new ExcelJS.Workbook();
            workbook.creator = "EmPortal";

            // ── Sheet 1: Detail ──
            const sheet1 = workbook.addWorksheet("AI Usage Detail", { views: [{ state: "frozen", ySplit: 1 }] });
            sheet1.columns = [
                { key: "id", width: 10 }, { key: "name", width: 30 }, { key: "projects", width: 32 },
                { key: "pm", width: 26 }, { key: "range", width: 24 }, { key: "using", width: 12 },
                { key: "tools", width: 35 }, { key: "other", width: 20 }, { key: "how", width: 45 }, { key: "result", width: 45 },
            ];
            const hdr1 = sheet1.addRow(["Ast ID", "Associate Name", "Projects", "Project Manager", "Date Range", "Using AI?", "Tools Used", "Other Tool", "Where & How Used", "Result / Outcome"]);
            hdr1.height = 22;
            hdr1.eachCell((c) => { c.font = { bold: true, color: { argb: WHITE }, size: 11 }; c.fill = solidFill(TEAL); c.alignment = { horizontal: "center", vertical: "middle", wrapText: true }; c.border = allBorders(BLACK); });

            associates.forEach((row, rIdx) => {
                const ai = parseAI(ratings?.[row?.associateId]?.aiUsageData);
                const isYes = ai?.isUsingAI === "yes";
                const isEven = rIdx % 2 === 0;
                const dataRow = sheet1.addRow([
                    row?.associateId ?? "", `${row.firstname ?? ""} ${row.lastname ?? ""}`.trim(),
                    row.projectTitles ?? "", row?.projectManager?.fullname ?? "", dateRange,
                    ai ? (isYes ? "Yes" : "No") : "—",
                    isYes ? (ai.tool ?? "") : "", isYes ? (ai.otherTool ?? "") : "",
                    isYes ? (ai.howAndWhere ?? "") : "", isYes ? (ai.result ?? "") : "",
                ]);
                dataRow.height = 36;
                dataRow.eachCell((c, col) => {
                    c.border = allBorders();
                    c.alignment = { vertical: "middle", horizontal: col === 1 ? "right" : "left", wrapText: true };
                    if (col === 6) {
                        c.font = { bold: true, color: { argb: WHITE }, size: 10 };
                        c.fill = solidFill(isYes ? GREEN : (ai ? GRAY : (isEven ? "FFF5F5F5" : WHITE)));
                        c.alignment = { horizontal: "center", vertical: "middle" };
                    } else {
                        c.font = { size: 10, color: { argb: BLACK } };
                        c.fill = solidFill(isEven ? LGRAY : WHITE);
                    }
                });
            });

            // ── Analytics: summary table + charts below detail data ──
            sheet1.addRow([]);
            sheet1.addRow([]);

            const addSummaryRow = (label, value, labelArgb, bold = false) => {
                const r = sheet1.addRow([label, value]);
                r.height = 20;
                r.getCell(1).font = { bold: bold || false, size: 11, color: { argb: labelArgb || BLACK } };
                r.getCell(1).fill = solidFill("FFE0F2F1");
                r.getCell(1).border = allBorders();
                r.getCell(2).font = { bold: bold || false, size: 11, color: { argb: labelArgb || BLACK } };
                r.getCell(2).fill = solidFill(WHITE);
                r.getCell(2).alignment = { horizontal: "center", vertical: "middle" };
                r.getCell(2).border = allBorders();
            };

            const metricHdr = sheet1.addRow(["Metric", "Count"]);
            metricHdr.height = 20;
            metricHdr.eachCell((c) => { c.font = { bold: true, color: { argb: WHITE }, size: 11 }; c.fill = solidFill(TEAL); c.alignment = { horizontal: "center", vertical: "middle" }; c.border = allBorders(BLACK); });

            addSummaryRow("Total Associates", total);
            addSummaryRow("Using AI (Yes)", usingYes, GREEN, true);
            addSummaryRow("Not Using AI (No)", usingNo, "FF9E9E9E");
            addSummaryRow("Not Answered", notAnswered, "FFE53935");
            addSummaryRow("AI Adoption Rate", `${pct(usingYes)}`, GREEN, true);

            sheet1.addRow([]);

            const toolHdr = sheet1.addRow(["Tool", "# Associates Using"]);
            toolHdr.height = 20;
            toolHdr.eachCell((c) => { c.font = { bold: true, color: { argb: WHITE }, size: 11 }; c.fill = solidFill(TEAL); c.alignment = { horizontal: "center", vertical: "middle" }; c.border = allBorders(BLACK); });

            sortedTools.forEach(([tool, count], rIdx) => {
                const r = sheet1.addRow([tool, count]);
                r.height = 18;
                r.getCell(1).font = { size: 10 }; r.getCell(1).fill = solidFill(rIdx % 2 === 0 ? LGRAY : WHITE); r.getCell(1).border = allBorders();
                r.getCell(2).font = { size: 10 }; r.getCell(2).fill = solidFill(rIdx % 2 === 0 ? LGRAY : WHITE); r.getCell(2).alignment = { horizontal: "center" }; r.getCell(2).border = allBorders();
            });

            // Charts below the analytics table
            const chartStartRow = sheet1.rowCount + 3;
            sheet1.addImage(workbook.addImage({ base64: donutPng, extension: "png" }), { tl: { col: 0, row: chartStartRow }, ext: { width: 420, height: 420 } });
            if (barPng) {
                sheet1.addImage(workbook.addImage({ base64: barPng, extension: "png" }), { tl: { col: 3, row: chartStartRow }, ext: { width: 700, height: barHeight } });
            }

            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), `AI_Usage_Report_${moment(startDate).format("DD-MM-YYYY")}_to_${moment(endDate).format("DD-MM-YYYY")}.xlsx`);

        } catch (err) {
            onError(err);
        }
    };

    const handleDownloadReportTwo = async (mode = "all") => {
        try {
            const [associatesRes, ratingsStatusRes] = await Promise.all([
                axiosInstance.post(
                    `/user/getAllassociatesforRatings?sortBy=${sortBy}&tenantId=${tenantId}&project=${project}`,
                    { startDate, endDate }
                ),
                axiosInstance.put(
                    `/user/getAllAssociateRatings?startDate=${startDate}&endDate=${endDate}&tenantId=${tenantId}`
                )
            ]);

            // Build a lookup for associate metadata (project, PM) keyed by associateId
            const associateMap = {};
            for (const row of associatesRes.data) {
                associateMap[row.associateId] = row;
            }


            const resolveUkScore = (item) =>
                item.projectManagerSubmission && item.ukScore > 0 ? item.ukScore : (item.lastPmUkScore || 0);

            let data;
            if (datefilter === "Last Bi-Weekly") {
                // Single period: match the one bi-weekly entry per associate
                data = ratingsStatusRes.data
                    .filter((item) => {
                        const itemStart = moment(item.startDate, ["DD-MMM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                        const itemEnd = moment(item.endDate, ["DD-MMM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                        return itemStart === startDate && itemEnd === endDate;
                    })
                    .map((item) => {
                        const assoc = associateMap[item.associateId] || {};
                        return {
                            associateId: item.associateId,
                            fullname: item.fullname || (assoc.firstname && assoc.lastname ? `${assoc.firstname} ${assoc.lastname}` : ""),
                            projectTitles: item.projectTitles || item.project || assoc.projectTitles || "",
                            projectManagerName: item.projectManagerName || item.projectManager?.fullname || "",
                            ukScore: resolveUkScore(item),
                            userSideSubmission: item.userSideSubmission || false,
                            projectManagerSubmission: item.projectManagerSubmission || false,
                            startDate,
                            endDate,
                        };
                    });

                // Apply submission filter for bi-weekly only
                if (submissionFilter !== "All") {
                    data = data.filter((item) => {
                        const isPMSubmitted = item.projectManagerSubmission;
                        const isSelfSubmitted = item.userSideSubmission && !item.projectManagerSubmission;
                        if (submissionFilter === "PM Submitted") return isPMSubmitted;
                        if (submissionFilter === "Self Submitted") return isSelfSubmitted;
                        if (submissionFilter === "Not Submitted") return !item.userSideSubmission && !item.projectManagerSubmission;
                        return true;
                    });
                }
            } else {
                // Multi-period range: one row per associate per bi-weekly period
                data = ratingsStatusRes.data.map((item) => {
                    const assoc = associateMap[item.associateId] || {};
                    const itemStart = moment(item.startDate, ["DD-MMM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                    const itemEnd = moment(item.endDate, ["DD-MMM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                    return {
                        associateId: item.associateId,
                        fullname: item.fullname || (assoc.firstname && assoc.lastname ? `${assoc.firstname} ${assoc.lastname}` : ""),
                        projectTitles: item.projectTitles || item.project || assoc.projectTitles || "",
                        projectManagerName: item.projectManagerName || item.projectManager?.fullname || "",
                        ukScore: resolveUkScore(item),
                        userSideSubmission: item.userSideSubmission || false,
                        projectManagerSubmission: item.projectManagerSubmission || false,
                        startDate: itemStart,
                        endDate: itemEnd,
                    };
                });
            }

            if (mode === "latest") {
                const latestMap = {};
                for (const item of data) {
                    const existing = latestMap[item.associateId];
                    if (!existing || item.endDate > existing.endDate ||
                        (item.endDate === existing.endDate && item.projectManagerSubmission && !existing.projectManagerSubmission) ||
                        (item.endDate === existing.endDate && item.projectManagerSubmission === existing.projectManagerSubmission && item.ukScore > existing.ukScore)) {
                        latestMap[item.associateId] = item;
                    }
                }
                data = Object.values(latestMap);
            }

            if (mode === "average") {
                const avgMap = {};
                for (const item of data) {
                    const id = item.associateId;
                    if (!avgMap[id]) {
                        avgMap[id] = { ...item, _ukScores: [], _pmNames: new Set(), _projects: new Set(), startDate, endDate };
                    }
                    if (item.ukScore > 0) avgMap[id]._ukScores.push(item.ukScore);
                    if (item.projectManagerName) avgMap[id]._pmNames.add(item.projectManagerName);
                    if (item.projectTitles) avgMap[id]._projects.add(item.projectTitles);
                }
                data = Object.values(avgMap).map((entry) => {
                    const avg = entry._ukScores.length > 0
                        ? Math.round(entry._ukScores.reduce((s, v) => s + v, 0) / entry._ukScores.length)
                        : 0;
                    return {
                        ...entry,
                        ukScore: avg,
                        projectManagerName: [...entry._pmNames].join(", "),
                        projectTitles: [...entry._projects].join(", "),
                    };
                });
            }

            const formattedData = data.map((item) => ({
                "Ast ID": item.associateId,
                "Associate Name": item.fullname,
                "Project": item.projectTitles || "N/A",
                "Project Manager": item.projectManagerName,
                "Date Range": `${moment(item.startDate).format("DD/MM/YYYY")} to ${moment(item.endDate).format("DD/MM/YYYY")}`,
                "UK Score": item.ukScore,
                "Self Rating": mode === "average" ? "-" : (item.userSideSubmission ? "Yes" : "No"),
                "PM Final Rating": mode === "average" ? "-" : (item.projectManagerSubmission ? "Yes" : "No"),
                "Combined Status": mode === "average" ? "-" : (item.userSideSubmission && item.projectManagerSubmission ? "Yes" : "No"),
                "_sortStart": item.startDate,
                "_carriedUkScore": mode !== "average" && item.projectManagerSubmission && item.ukScore > 0,
            }));

            formattedData.sort((a, b) => a["Ast ID"] - b["Ast ID"] || a["_sortStart"].localeCompare(b["_sortStart"]));

            const lastPmIdxMap = {};
            formattedData.forEach((row, idx) => { if (row["_carriedUkScore"]) lastPmIdxMap[row["Ast ID"]] = idx; });
            formattedData.forEach((row, idx) => { row["_carriedUkScore"] = row["_carriedUkScore"] && idx === lastPmIdxMap[row["Ast ID"]]; });

            await exportBiWeeklyRatingsExcel({ formattedData, mode, startDate, endDate });
        } catch (err) {
            onError(err);
        }
    };




    return (
        <div>
            <ReportComponent {...props}
                type={"Appraisals"}
                handleDownloadReport={handleDownloadReport}
                handleDownloadReportExcel={handleDownloadReportExcel}
                handleDownloadReportTwo={handleDownloadReportTwo}
                handleDownloadAIReport={handleDownloadAIReport}
                datefilter={datefilter}
                setStartDate={setStartDate}
                startDate={startDate}
                endDate={endDate}
                setDateFilter={setDateFilter}
                setRatingsEndDate={setRatingsEndDate}
                onSubmissionFilterChange={setSubmissionFilter}
                setEndDate={setEndDate}
                startDateError={startDateError}
                endDateError={endDateError}
                setStartDateError={setStartDateError}
                setEndDateError={setEndDateError}
                tenantId={tenantId}
                setTenantId={setTenantId}
                sortBy={sortBy}
                appType={appType}
                setFilteredElements={setFilteredElements}
                setAppType={setAppType}
                setSortBy={setSortBy}
                project={project}
                setProject={setProject}
                displayAdd={false}
            />
        </div>
    )
}

export default AdminScreenAppraisal
